










import { Vue, Component } from 'vue-property-decorator';
import CamaraHik from '@/pantallas/Camaras/Hik/CamaraHik.vue';

@Component({
  components: { CamaraHik },
})
export default class HikPantalla extends Vue {}
